import React, { useRef, useEffect } from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const UserDropdown = ({ user, onClose }) => {
  const { logout } = useAuth();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const handleLogout = async () => {
    await logout();
    onClose();
  };

  return (
    <div className="user-dropdown" ref={dropdownRef}>
      <button onClick={handleLogout} className="user-dropdown-item logout">
        <LogOut size={18} />
        Logout
      </button>
    </div>
  );
};

export default UserDropdown;
